var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcWalletBinance = function SvgIcWalletBinance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_wallet_binance_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0V0Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.997 12.504h-.002L10.001 16.5l-3.994-3.993-.002-.002 1.472-1.467L10 13.562l2.526-2.525 1.47 1.467ZM11.491 10h.001l-1.491 1.491-1.49-1.488L8.51 10l.002-.003.26-.26.127-.127 1.102-1.101L11.491 10Zm5.009.001-1.469 1.469L13.562 10l1.47-1.469 1.468 1.469ZM6.437 10 4.97 11.469 3.5 10l1.469-1.469L6.437 10Zm7.558-2.505-1.468 1.47-2.526-2.527-2.524 2.525-1.47-1.469L10 3.5l3.994 3.995Z",
    fill: "#F3BA2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_wallet_binance_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#fff"
  })))));
};
export default SvgIcWalletBinance;